import React from 'react'

export default function SearchbarStyle() {
  return (
    <style jsx='true'>
    {`
      .search-tooltip {
        background-color: rgba(10, 10, 119, 0.8);
        text-align: center;
        margin-left: 5px;
        padding: 10px 15px;
        border-radius: 3px;
        font-size: 0.7em;
        color: whitesmoke;
        position: absolute;
        top: 9.8%;
        z-index: 1;
      }

      #search {
        flex: 10;
        padding-left: 5px;
        font-size: 0.7em;
        border-radius: var(--search-control-radius);
        border: none;
        outline: none;
      }

      .search-control-container {
        background-color: white;
        border: solid 0.2px rgba(165, 209, 158, 1);
        border-radius: var(--search-control-radius);
        display: flex;
        margin: auto;
        padding: 5px 5px;
        flex: 5;
      }

      .search-control-container-shadow { box-shadow: 1px 1px 2px 1px #BBB; }

      .spyglass-container {
        display: flex;
        font-size: 0.95rem;
        color: lightgrey;
        justify-content: center;
        align-items: center;
        padding: 5px;
      }
    `}
    </style>
  )
}
